import { createDynamicThunk } from ".";

/**
 * LIST Permissions
 */
export const fetchPermissionsThunk = createDynamicThunk({
  typePrefix: "permissions/fetchPermissionsThunk",
  useHandleSearch: true,
});

/**
 * ADD / EDIT Permission
 */
export const submitPermissionsThunk = createDynamicThunk({
  typePrefix: "permissions/submitPermissionThunk",
  endpoint: "/permissions",
  method: "POST",
});